module.exports = __webpack_public_path__ + "media/app_search/Billing/assets/credit_cards/visa-a5a1c572a734c76f2248450b436ddadc.svg";